"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.RadioInput = exports.CheckboxInput = exports.SelectInput = exports.TextareaAutosize = exports.TextareaInput = exports.NumberInput = exports.HiddenInput = exports.MASK_TYPES = exports.MaskInput = exports.TextInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _formElements = require("@evidation/form-elements");

var _propTypes = require("prop-types");

var _radioCheckboxLabelHolder = _interopRequireDefault(require("./labels/radioCheckboxLabelHolder"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
// TextInput
//
var TextInput = function TextInput(_ref) {
  var _ref$config = _ref.config,
      _ref$config$type = _ref$config.type,
      type = _ref$config$type === void 0 ? "text" : _ref$config$type,
      config = (0, _objectWithoutProperties2["default"])(_ref$config, ["type"]),
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["config"]);
  // ensuring `textinput` doesn't get passed to the field
  var t = type === "textinput" ? "text" : type;

  var props = _objectSpread(_objectSpread({}, rest), {}, {
    config: _objectSpread(_objectSpread({}, config), {}, {
      type: t
    })
  });

  return /*#__PURE__*/_react["default"].createElement(_formElements.TextInput, (0, _utils.util_commonInputParamters)(props));
}; //
// MaskInput
//


exports.TextInput = TextInput;

var MaskInput = function MaskInput(rest) {
  var _util_commonInputPara = (0, _utils.util_commonInputParamters)(rest),
      _onChange = _util_commonInputPara.onChange,
      params = (0, _objectWithoutProperties2["default"])(_util_commonInputPara, ["onChange"]);

  var mask = rest.config.mask ? rest.config.mask : "11111";
  return /*#__PURE__*/_react["default"].createElement(_formElements.MaskedInput, (0, _extends2["default"])({}, params, {
    onChange: function onChange(e) {
      var value = e.target.value;

      if (value.length === 0) {
        // this is a hack to force an invalid value of a mask field
        // if the user types an answer, and deletes the whole thing
        // For some reason this causes redux form to not fire and
        // evaluate an empty value
        _onChange("_");
      } else {
        _onChange(e.target.value);
      }
    },
    mask: mask
  }));
};

exports.MaskInput = MaskInput;
var MASK_TYPES = {
  bloodPressure: "111 mm Hg / 111 mm Hg"
}; //
// HiddenInput
//

exports.MASK_TYPES = MASK_TYPES;

var HiddenInput = function HiddenInput(rest) {
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "hiddenInput"
  }, /*#__PURE__*/_react["default"].createElement(_formElements.TextInput, (0, _extends2["default"])({}, (0, _utils.util_commonInputParamters)(rest), {
    type: "hidden"
  })));
}; //
// NumberInput
//


exports.HiddenInput = HiddenInput;

var NumberInput = function NumberInput(rest) {
  return /*#__PURE__*/_react["default"].createElement(_formElements.NumberInput, (0, _utils.util_commonInputParamters)(rest));
}; //
// TextareaInput
//


exports.NumberInput = NumberInput;

var TextareaInput = function TextareaInput(rest) {
  return /*#__PURE__*/_react["default"].createElement(_formElements.TextareaInput, (0, _utils.util_commonInputParamters)(rest));
}; //
// TextareaAutosize
//


exports.TextareaInput = TextareaInput;

var TextareaAutosize = function TextareaAutosize(rest) {
  return /*#__PURE__*/_react["default"].createElement(_formElements.TextareaAutosize, (0, _utils.util_commonInputParamters)(rest));
}; //
// SelectInput
//


exports.TextareaAutosize = TextareaAutosize;

var SelectInput = function SelectInput(rest) {
  return /*#__PURE__*/_react["default"].createElement(_formElements.SelectInput, (0, _extends2["default"])({}, (0, _utils.util_commonInputParamters)(rest), {
    options: rest.config.options
  }));
}; //
// Checkbox
//


exports.SelectInput = SelectInput;

var CheckboxInput = function CheckboxInput(rest) {
  var _util_commonInputPara2 = (0, _utils.util_commonInputParamters)(rest),
      label = _util_commonInputPara2.label,
      labelStyle = _util_commonInputPara2.labelStyle,
      style = _util_commonInputPara2.style,
      children = _util_commonInputPara2.children,
      error = _util_commonInputPara2.error,
      options = _util_commonInputPara2.options,
      value = _util_commonInputPara2.value,
      props = (0, _objectWithoutProperties2["default"])(_util_commonInputPara2, ["label", "labelStyle", "style", "children", "error", "options", "value"]);

  var v = value;

  if (_lodash["default"].isString(value)) {
    v = true;

    if (_lodash["default"].trim(value) === "" || _lodash["default"].trim(value) === "false") {
      v = false;
    }
  }

  var passedProps = {
    label: label,
    labelStyle: labelStyle,
    labelFor: props.id,
    style: {
      marginTop: 10
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_radioCheckboxLabelHolder["default"], passedProps, /*#__PURE__*/_react["default"].createElement(_formElements.CheckboxInput, (0, _extends2["default"])({}, props, {
    value: v
  }))), rest.meta.touched && error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, {
    style: {
      marginTop: -10
    }
  }, error));
}; //
// Radio
//


exports.CheckboxInput = CheckboxInput;

var RadioInput = function RadioInput(rest) {
  return /*#__PURE__*/_react["default"].createElement(_formElements.RadioInput, (0, _utils.util_commonInputParamters)(rest));
}; //
// Button
//


exports.RadioInput = RadioInput;

var Button = function Button(rest) {
  var Label = rest.label,
      props = (0, _objectWithoutProperties2["default"])(rest, ["label"]);
  return /*#__PURE__*/_react["default"].createElement(_formElements.Button, (0, _extends2["default"])({
    type: 'button',
    className: 'button'
  }, props), Label);
};

exports.Button = Button;
Button.defaultProps = {
  label: 'submit'
};
Button.propTypes = {
  onClick: _propTypes.func.isRequired,
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node, _propTypes.element, _propTypes.func])
};